import moment from 'moment';

class LeaveAdjustmentsController {
  constructor($uibModalInstance, yearStats, leaveType, $http, $rootScope) {
    "ngInject";
    this.$uibModalInstance = $uibModalInstance;
    this.yearStats = yearStats;
    this.leaveType = leaveType;
    this.$http = $http;
    this.$rootScope = $rootScope;
    
    this.adjustments = [];
    this.sortedAdjustments = [];
    this.loading = true;
    this.error = null;
    this.currentPage = 1;
    this.itemsPerPage = 10;
    
    // Fetch leave adjustments from REST service
    this.fetchLeaveAdjustments();
  }

  /**
   * Fetch leave adjustments from REST service
   */
  fetchLeaveAdjustments() {
       
    const year = this.yearStats.selectedYear;
    const url = `${this.$rootScope.apiHost}/api/leave/me/${this.leaveType.leaveTypeName}/adjustments/${year}`;
    
    this.$http.get(url, {withCredentials: true})
      .then((response) => {
        this.loading = false;
        this.adjustments = response.data || [];
        // Sort by date ascending
        this.sortAdjustmentsByDate();
      })
      .catch((error) => {
        this.loading = false;
        this.error = error.data.message || 'Failed to load leave adjustments';
        this.adjustments = [];
        this.sortedAdjustments = [];
      });
  }

  /**
   * Sort adjustments by date ascending
   */
  sortAdjustmentsByDate() {
    this.sortedAdjustments = [...this.adjustments].sort((a, b) => {
      const dateA = moment(a.changeDate);
      const dateB = moment(b.changeDate);
      return dateA.isBefore(dateB) ? -1 : dateA.isAfter(dateB) ? 1 : 0;
    });
  }

  /**
   * Get paginated adjustments
   * @returns {Array} Paginated array of adjustments
   */
  getPaginatedAdjustments() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.sortedAdjustments.slice(startIndex, endIndex);
  }

  /**
   * Get total number of pages
   * @returns {number} Total number of pages
   */
  getTotalPages() {
    return Math.ceil(this.sortedAdjustments.length / this.itemsPerPage);
  }

  /**
   * Go to next page
   */
  nextPage() {
    const totalPages = this.getTotalPages();
    if (this.currentPage < totalPages) {
      this.currentPage++;
    }
  }

  /**
   * Go to previous page
   */
  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  /**
   * Format date for display
   * @param {string|Date} date - Date to format (LocalDate from backend)
   * @returns {string} Formatted date string
   */
  formatDate(date) {
    if (!date) return '';
    // LocalDate is typically serialized as "YYYY-MM-DD" string
    return moment(date).format('MMM DD, YYYY');
  }

  /**
   * Close the modal
   */
  close() {
    this.$uibModalInstance.dismiss();
  }
}

export default LeaveAdjustmentsController;




// WEBPACK FOOTER //
// ./client/pages/leave/modals/leave-adjustments/leave-adjustments.controller.js